import { iconNames } from '@zapier/design-system';
export const buttonNavSectionConfig = {
    name: 'ButtonNavSection',
    category: 'Zapier Sections',
    includeScrollTracking: true,
    image: 'https://cdn.zappy.app/e8dc67f858721d45983ebb99b3372db1.png',
    inputs: [
        {
            name: 'buttons',
            type: 'list',
            required: true,
            subFields: [
                {
                    name: 'text',
                    type: 'string',
                    required: true,
                    defaultValue: 'Lead management',
                },
                {
                    name: 'iconBefore',
                    type: 'string',
                    enum: ['', ...Object.keys(iconNames)],
                },
                {
                    name: 'content',
                    type: 'uiBlocks',
                    hideFromUI: true,
                    defaultValue: [],
                },
            ],
            defaultValue: [
                {
                    text: 'Lead management',
                    content: [],
                },
            ],
        },
        {
            name: 'perRow',
            type: 'number',
            defaultValue: 4,
        },
        {
            name: 'align',
            type: 'string',
            enum: ['left', 'center', 'right'],
        },
        {
            name: 'isButtonFullWidth',
            type: 'boolean',
            defaultValue: true,
        },
        { name: 'wrap', type: 'boolean', defaultValue: true },
    ],
};
//# sourceMappingURL=config.js.map